import { Component, Input, OnInit } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { ERR_MESSAGE } from "src/app/components/constants/error";
import { ResponseScannedQr } from "src/app/models/responseScannedQr";
import { Transactions } from "src/app/models/transactions.model";
import { PaymentService } from "src/app/services/payment.service";
import { QrGeneratorService } from "src/app/services/qrGenerator.service";

@Component({
  selector: "app-payment",
  templateUrl: "./payment.component.html",
  styleUrls: ["./payment.component.css"],
})
export class PaymentComponent implements OnInit {
  @Input() transaction!: Transactions;
  @Input() transferID!: string;
  @Input() type!: string;

  public isLoading: boolean = false;
  public showPayButton: boolean = true;
  public canChangeTotal: boolean = false;

  constructor(
    private qrService: QrGeneratorService,
    private paymentService: PaymentService,
    private router: Router,
    private translateService: TranslateService,
    private _snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.calculateHours(this.transaction.createDate);
  }

  checkComment() {
    return this.transaction.comment.trim();
  }

  onPay() {
    if (this.isLoading) return;
    this.isLoading = true;

    this.qrService.scanQr(this.transaction["qr"]).subscribe(
      (res) => {
        let body = res.body as ResponseScannedQr;
        let sendBodyForLink = body["response"];
        let hash = body["hash"];
        let lang = !!localStorage.getItem("lang")
          ? localStorage.getItem("lang")
          : "hy";
        lang = lang == "am" ? "hy" : lang;

        this.paymentService.pay(sendBodyForLink, lang).subscribe(
          (res) => {
            this.isLoading = false;
            if (res.status == 201) {
              if (hash != null) {
                this.router.navigateByUrl(`transfer_success/${hash}`);
                return;
              }
              this.router.navigateByUrl(`transfer_success/${this.transferID}`);
            } else {
              window.location.href = res.body["formUrl"];
            }
          },
          (err) => {
            this.isLoading = false;
            let errMessage: string = "";
            this.translateService.get("deals").subscribe((res) => {
              errMessage = res.errorMessage1;
              this._snackBar.open(errMessage || ERR_MESSAGE, "", {
                duration: 7000,
              });
            });
          }
        );
      },
      (err) => {
        this.isLoading = false;
        let errmer = err?.error?.message?.trim();
        this._snackBar.open(errmer || ERR_MESSAGE, "", {
          duration: 7000,
        });
      }
    );
  }

  calculateHours(createDate: Date) {
    let tansactionDate = new Date(createDate).getTime();
    let currentDate = new Date().getTime();
    let time_difference = Math.abs(currentDate - tansactionDate);
    let hours_difference = Math.floor(time_difference / (1000 * 3600));
    if (hours_difference > 48) this.showPayButton = false;
    else this.showPayButton = true;
    console.log(this.showPayButton);
  }

  goBack() {
    this.router.navigateByUrl(`px_transfer/${this.transferID}`);
  }
}
